import ReportTab from './ReportTab'
import ProcessTab from './ProcessTab'
import MaterialTab from './MaterialTab'
import PrintTab from './PrintTab'
import PressTab from './PressTab'
import SewingTab from './SewingTab'
import CutTab from './CutTab'

// Mỗi tab nhận {tab, data}: tab là phần tử của TABS, data là envelope của GET /report/ng-rate/tabs/:tab
export default {
    report: ReportTab,
    process: ProcessTab,
    material: MaterialTab,
    print: PrintTab,
    press: PressTab,
    sewing: SewingTab,
    cut: CutTab,
}
